/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VerifyKYCStepOneParam { 
    /**
     * Front photo of the identity card to be verified. Must be a .jpeg
     */
    identityCardFrontPhoto: string;
    /**
     * Back photo of the identity card to be verified. Must be a .jpeg
     */
    identityCardBackPhoto?: string;
    /**
     * Passport photo to be verified. Must be a .jpeg
     */
    passportPhoto: string;
}

